/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  OrganizationCreate,
  OrganizationRead,
  OrganizationSummary,
  OrganizationUserUpdate,
  UserOrganization,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    OrganizationCreateFromJSON,
    OrganizationCreateToJSON,
    OrganizationReadFromJSON,
    OrganizationReadToJSON,
    OrganizationSummaryFromJSON,
    OrganizationSummaryToJSON,
    OrganizationUserUpdateFromJSON,
    OrganizationUserUpdateToJSON,
    UserOrganizationFromJSON,
    UserOrganizationToJSON,
} from '../models/index';

export interface UserCreateOrganizationRequest {
    organizationCreate: OrganizationCreate;
}

export interface UserDeleteOrganizationRequest {
    orgId: string;
}

export interface UserGetOrganizationRequest {
    orgId: string;
}

export interface UserSearchOrganizationsRequest {
    q?: string;
    limit?: number;
}

export interface UserUpdateOrganizationRequest {
    orgId: string;
    organizationUserUpdate: OrganizationUserUpdate;
}

/**
 * 
 */
export class OrganizationsApi extends runtime.BaseAPI {

    /**
     * Create a new organization with the provided name. The current user will be set as the owner and administrator of the organization. Requires a valid, unused license key.
     * User Create Organization
     */
    async userCreateOrganizationRaw(requestParameters: UserCreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationRead>> {
        if (requestParameters['organizationCreate'] == null) {
            throw new runtime.RequiredError(
                'organizationCreate',
                'Required parameter "organizationCreate" was null or undefined when calling userCreateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationCreateToJSON(requestParameters['organizationCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationReadFromJSON(jsonValue));
    }

    /**
     * Create a new organization with the provided name. The current user will be set as the owner and administrator of the organization. Requires a valid, unused license key.
     * User Create Organization
     */
    async userCreateOrganization(requestParameters: UserCreateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationRead> {
        const response = await this.userCreateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft delete an organization by setting the is_active flag to False. Only organization owners or administrators can delete organizations, and only while the organization holds a valid license (403 `Organization license required`; superadmins exempt).
     * User Delete Organization
     */
    async userDeleteOrganizationRaw(requestParameters: UserDeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationRead>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling userDeleteOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{org_id}`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationReadFromJSON(jsonValue));
    }

    /**
     * Soft delete an organization by setting the is_active flag to False. Only organization owners or administrators can delete organizations, and only while the organization holds a valid license (403 `Organization license required`; superadmins exempt).
     * User Delete Organization
     */
    async userDeleteOrganization(requestParameters: UserDeleteOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationRead> {
        const response = await this.userDeleteOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return all organizations the current user is a member of, with their roles. Accessible by all authenticated users.
     * User Get All Organizations
     */
    async userGetAllOrganizationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserOrganization>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserOrganizationFromJSON));
    }

    /**
     * Return all organizations the current user is a member of, with their roles. Accessible by all authenticated users.
     * User Get All Organizations
     */
    async userGetAllOrganizations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserOrganization>> {
        const response = await this.userGetAllOrganizationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get details of a specific organization including license information. Only organization members can view organization details.
     * User Get Organization
     */
    async userGetOrganizationRaw(requestParameters: UserGetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationRead>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling userGetOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{org_id}`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationReadFromJSON(jsonValue));
    }

    /**
     * Get details of a specific organization including license information. Only organization members can view organization details.
     * User Get Organization
     */
    async userGetOrganization(requestParameters: UserGetOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationRead> {
        const response = await this.userGetOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search active organizations by name, for inviting them to an event.  Competition organizers and superadmins only; returns id and name, ordered by name.
     * User Search Organizations
     */
    async userSearchOrganizationsRaw(requestParameters: UserSearchOrganizationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationSummary>>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationSummaryFromJSON));
    }

    /**
     * Search active organizations by name, for inviting them to an event.  Competition organizers and superadmins only; returns id and name, ordered by name.
     * User Search Organizations
     */
    async userSearchOrganizations(requestParameters: UserSearchOrganizationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationSummary>> {
        const response = await this.userSearchOrganizationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing organization with the provided data. Only organization owners or administrators can update organizations.
     * User Update Organization
     */
    async userUpdateOrganizationRaw(requestParameters: UserUpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationRead>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling userUpdateOrganization().'
            );
        }

        if (requestParameters['organizationUserUpdate'] == null) {
            throw new runtime.RequiredError(
                'organizationUserUpdate',
                'Required parameter "organizationUserUpdate" was null or undefined when calling userUpdateOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{org_id}`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationUserUpdateToJSON(requestParameters['organizationUserUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationReadFromJSON(jsonValue));
    }

    /**
     * Update an existing organization with the provided data. Only organization owners or administrators can update organizations.
     * User Update Organization
     */
    async userUpdateOrganization(requestParameters: UserUpdateOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationRead> {
        const response = await this.userUpdateOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
